export type EventData = Record<string, string | number | boolean>;

export type EventTrackingFunction = (
    eventName: string,
    data?: EventData,
) => void;

export enum InteractionEvent {
    MoneyMapEarningsCalculatorOpened = 'MoneyMapEarningsCalculatorOpened',
    MoneyMapEarningsCalculatorClosed = 'MoneyMapEarningsCalculatorClosed',
    MoneyMapEarningsCalculatorCTAPressed = 'MoneyMapEarningsCalculatorCTAPressed',
}
